// Sage

export const fetchFiles = (page: number): sage.actions.file.IFetchFiles => {
    return {
        type: "com.sage.actions.file.IFetchFiles",
        page,
    };
};

export const downloadFile = (
    fileId: string
): sage.actions.file.IDownloadFile => {
    return {
        type: "com.sage.actions.file.IDownloadFile",
        fileId,
    };
};

export const fetchFile = (fileId: string): sage.actions.file.IFetchFile => {
    return {
        type: "com.sage.actions.file.IFetchFile",
        fileId,
    };
};

export const fetchFileInfo = (
    fileId: string
): sage.actions.file.IFetchFileInfo => {
    return {
        type: "com.sage.actions.file.IFetchFileInfo",
        fileId,
    };
};

// Redux

export const setFiles = (
    page: number,
    files: sage.model.IFile[]
): sage.actions.file.ISetFiles => {
    return {
        type: "com.sage.actions.file.ISetFiles",
        page,
        files,
    };
};

export const setFilesStatus = (
    page: number,
    status: sage.status.Fetch
): sage.actions.file.ISetFilesStatus => {
    return {
        type: "com.sage.actions.file.ISetFilesStatus",
        page,
        status,
    };
};

export const setDownloadFileStatus = (
    fileId: string,
    status: sage.status.Fetch
): sage.actions.file.ISetDownloadFileStatus => {
    return {
        type: "com.sage.actions.file.ISetDownloadFileStatus",
        fileId,
        status,
    };
};

export const setFileStatus = (
    fileId: string,
    status: sage.status.Fetch
): sage.actions.file.ISetFileStatus => {
    return {
        type: "com.sage.actions.file.ISetFileStatus",
        status,
        fileId,
    };
};

export const setFile = (file: sage.model.IFile): sage.actions.file.ISetFile => {
    return {
        type: "com.sage.actions.file.ISetFile",
        file,
    };
};

export const setFileInfo = (
    fileInfo: sage.model.IFileInfo
): sage.actions.file.ISetFileInfo => {
    return {
        type: "com.sage.actions.file.ISetFileInfo",
        fileInfo,
    };
};

export const setFileInfoStatus = (
    fileId: string,
    status: sage.status.FileInfo
): sage.actions.file.ISetFileInfoStatus => {
    return {
        type: "com.sage.actions.file.ISetFileInfoStatus",
        fileId,
        status,
    };
};
